import { compose } from '@fluentui/react-bindings';
import * as customPropTypes from '@fluentui/react-proptypes';
import * as PropTypes from 'prop-types';
import { commonPropTypes } from '../../utils';
import { Box } from '../Box/Box';
export var menuItemWrapperClassName = 'ui-menu__itemwrapper';
/**
 * A MenuItemWrapper allows a user to have a dedicated component that can be targeted from the theme.
 */

export var MenuItemWrapper = /*#__PURE__*/function () {
  var MenuItemWrapper = compose(Box, {
    className: menuItemWrapperClassName,
    displayName: 'MenuItemWrapper',
    mapPropsToStylesProps: function mapPropsToStylesProps(props) {
      return {
        active: props.active,
        disabled: props.disabled,
        iconOnly: props.iconOnly,
        isFromKeyboard: props.isFromKeyboard,
        pills: props.pills,
        pointing: props.pointing,
        secondary: props.secondary,
        underlined: props.underlined,
        vertical: props.vertical,
        primary: props.primary,
        on: props.on
      };
    },
    handledProps: ['active', 'disabled', 'iconOnly', 'isFromKeyboard', 'pills', 'pointing', 'secondary', 'underlined', 'vertical', 'primary', 'on'],
    overrideStyles: true,
    shorthandConfig: {
      mappedProp: 'content'
    }
  });
  MenuItemWrapper.defaultProps = {
    as: 'li'
  };
  MenuItemWrapper.propTypes = Object.assign({}, commonPropTypes.createCommon(), {
    active: PropTypes.bool,
    disabled: PropTypes.bool,
    iconOnly: PropTypes.bool,
    isFromKeyboard: PropTypes.bool,
    pills: PropTypes.bool,
    pointing: PropTypes.oneOf(['start', 'end', true, false]),
    primary: customPropTypes.every([customPropTypes.disallow(['secondary']), PropTypes.bool]),
    secondary: customPropTypes.every([customPropTypes.disallow(['primary']), PropTypes.bool]),
    underlined: PropTypes.bool,
    vertical: PropTypes.bool
  });
  return MenuItemWrapper;
}();
//# sourceMappingURL=MenuItemWrapper.js.map
